import { InjectionToken } from '@angular/core';

export interface AppConfig {
  featureFlags: string;
}

export const CONFIG = new InjectionToken<AppConfig>('Application config', {
  providedIn: 'root',
  factory: () => ({
    featureFlags: '',
  }),
});
